// require styles
require('normalize.css')
require('animate.css')
require('superkit-teambition/dist/main.css')
require('@/styles/global/index.less')
require('vue-video-player/src/custom-theme.css')
require('@/styles/videojs-matrix.less')
require('video.js/dist/video-js.css')
// eslint-disable-next-line import/no-extraneous-dependencies
require('quill/dist/quill.core.css')

/* eslint-disable */
import 'babel-polyfill'
import Vue from 'vue'
import app from '@/app'
import router from '@/router'
import store from '@/store'
import * as tbc from 'superkit-teambition'
import VueI18n from 'vue-i18n'
import VideoPlayer from 'vue-video-player'
import { getLang } from '@/utils'
import fetch from 'isomorphic-fetch'

Vue.use(VideoPlayer);
Vue.use(VueI18n)
Vue.use(tbc)

Vue.config.productionTip = false

const CN = require('@/utils/lang/cn')
const US = require('@/utils/lang/en')

if (!localStorage.TB_APP_LANG) {
  localStorage.TB_APP_LANG = 'zh-CN'
}

const i18n = new VueI18n({
  locale: localStorage.TB_APP_LANG,   // 语言标识，通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': CN,   // 中文语言包
    'en-US': US   // 英文语言包
  }
})

const url = location.href.split('#')[0];
fetch('https://wechatservice.daguchuangyi.com/jssdk', {
  method: 'POST',
  body: JSON.stringify({ url, wechatid: '585cab1b49e1b82c8b8f6086' }),
  headers: {
    'Content-Type': 'application/json'
  }
}).then((response) => {
  response.text().then((responseText) => {
    const data = JSON.parse(responseText);
    wx.config({
      debug: false,
      appId: data.appid,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'startRecord',
        'stopRecord',
        'onVoiceRecordEnd',
        'translateVoice'
      ],
    });
  });
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<app />',
  components: { app },
})



// WEBPACK FOOTER //
// ./src/main.js